import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Row, Col, Form, Button, Alert } from "react-bootstrap";
import { signUp, resetSignUp } from "../../actions/auth-action";
import { Redirect, useHistory } from "react-router-dom";
import useInput from "../hooks/useInput";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import "./MandalaSignUp.scss";

const MandalaSignUp = (props) => {
  const { signUp, resetSignUp } = props;
  const { search } = useLocation();
  const query = queryString.parse(search);

  const signUpError = useSelector((state) => state.auth.signUpError);
  const signUpRedirect = useSelector((state) => state.auth.signUpRedirect);
  const signUpStart = useSelector((state) => state.auth.signUpStart);
  const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);

  const history = useHistory();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [checked, setChecked] = useState(false);
  const [referralCode, bindReferralCode] = useInput(query.ref || "");

  useEffect(() => {
    resetSignUp();
    return () => {
      resetSignUp();
    };
  }, [resetSignUp]);

  const clickSignUp = (e) => {
    e.preventDefault();
    signUp({
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      password_confirmation: confirmPass,
      from: "web",
      partner: "mandala",
      referral_code: referralCode,
    });
  };
  if (signUpRedirect) {
    return <Redirect to="/verify-otp" />;
  }
  return (
    <div className="mandala-signup">
      <Row>
        <Col className="left-panel" style={{backgroundColor:"#000"}}>
          <div>
            <img
              src="/images/ch3.png"
              className="crytohero-image"
              width="150"
            />
            <img src="/images/mandala.png" className="mandala-image" width="180" />
          </div>
          <div>
            <img src="/images/mandala-signup.png" className="feature-image" />
          </div>
        </Col>
        <Col className="right-panel">
          <div className="signup-panel">
            <h6 className="mt-2 header-text">Create New Account</h6>
            <Form>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="First name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Last name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mandala-form">
                <Form.Control
                  as="input"
                  placeholder="Repeat password"
                  type="password"
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="ch-form">
                  <Form.Control
                    as="input"
                    placeholder="Referral code"
                    {...bindReferralCode}
                    disabled={query.ref != null}
                  />
                </Form.Group>
              <Form.Check
                label={
                  <p>
                    I agree to CFDHero’s {" "}
                    <a className="terms-mandala"
                      href="https://CFDHero.ai/terms-of-service/"
                      target="_blank"
                    >
                      Terms of service
                    </a>
                  </p>
                }
                className="terms"
                value={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              <div className="my-3">
                <Button
                  type="submit"
                  onClick={clickSignUp}
                  className={"mandala-button"}
                  disabled={!checked}
                >
                  {signUpStart ? "SUBMITTING..." : "SIGN UP"}
                </Button>
                <Button
                  type="submit"
                  onClick={() => history.push("/dashboard")}
                  className={"mandala-button-login"}
                >
                  LOGIN
                </Button>
              </div>

              <Alert
                show={signUpError != null || signUpSuccess}
                variant={signUpSuccess ? "success" : "danger"}
                className="mt-2"
              >
                {signUpError || "Account has been created!"}
              </Alert>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, { signUp, resetSignUp })(MandalaSignUp);
